import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { dialogActions } from "../../store/dialogSlice";
import Modal from "../UI/Modal";
import NoticeForm from "./NoticeForm";
import checkCircleImg from "../../assets/icons/check-circle.png";

import { useEffect } from "react";

export default function DeleteCompleteDialog() {
  const deleteCompleteDialogIsOpen = useSelector(
    (state) => state.dialog.deleteComplete.isOpen
  );
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function handleConfirm() {
    dispatch(dialogActions.setDeleteCompleteIsOpen(false));
  }
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        // ESC 키를 누를 때 기본 동작을 차단
        event.preventDefault();
      }
    };

    if (deleteCompleteDialogIsOpen) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [deleteCompleteDialogIsOpen]);
  return (
    <Modal
      open={deleteCompleteDialogIsOpen}
      className={"modal w-[476px] h-[266px] modal_notice"}
    >
      <NoticeForm
        icon={<img src={checkCircleImg} alt={"complete"} />}
        title={t("delete_dialog.conf_noti.title")}
        description={t("delete_dialog.conf_noti.description")}
        isOneButton={true}
        confirmTitle={t("button.confirm")}
        handleConfirm={handleConfirm}
      />
    </Modal>
  );
}
